var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-container"},[_c('legend',[_vm._v(_vm._s(_vm.legend))]),_c('input',{staticClass:"input",attrs:{"type":"time","disabled":_vm.disabled},domProps:{"value":_vm.modelValue},on:{"input":function($event){return _vm.$emit('update:modelValue', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }